// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__OBA3r {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: left;
    display: flex;
    padding-bottom: 120px;
    z-index: 60;
    background: rgba(214, 214, 214, 0.85);
}

.styles_popup__z2leu {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 680px;
    margin: auto;
    background: #fbfbfc;
    border-radius: 6px;
    border: 4px double rgba(112, 112, 112, 0.25);
}

.styles_popup__z2leu p {
    margin: 0 0 32px;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    white-space: pre-line;
}

.styles_header__NlGNa {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 34px 34px;
    grid-gap: 16px;
    border-bottom: 1px solid var(--light-grey);
}

.styles_body__XizeN {
    padding: 34px 34px 55px;
}

.styles_bts__rIWbu {
    display: flex;
    justify-content: center;
    grid-gap: 20px;
}

.styles_close__O65yr {
    /*position: relative;*/
    /*top: -40px;*/
    /*right: -20px;*/
}
`, "",{"version":3,"sources":["webpack://./src/components/DeletePopup/styles.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n    display: flex;\n    padding-bottom: 120px;\n    z-index: 60;\n    background: rgba(214, 214, 214, 0.85);\n}\n\n.popup {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 680px;\n    margin: auto;\n    background: #fbfbfc;\n    border-radius: 6px;\n    border: 4px double rgba(112, 112, 112, 0.25);\n}\n\n.popup p {\n    margin: 0 0 32px;\n    font-size: 18px;\n    line-height: 20px;\n    text-align: center;\n    white-space: pre-line;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 34px 34px;\n    grid-gap: 16px;\n    border-bottom: 1px solid var(--light-grey);\n}\n\n.body {\n    padding: 34px 34px 55px;\n}\n\n.bts {\n    display: flex;\n    justify-content: center;\n    grid-gap: 20px;\n}\n\n.close {\n    /*position: relative;*/\n    /*top: -40px;*/\n    /*right: -20px;*/\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__OBA3r`,
	"popup": `styles_popup__z2leu`,
	"header": `styles_header__NlGNa`,
	"body": `styles_body__XizeN`,
	"bts": `styles_bts__rIWbu`,
	"close": `styles_close__O65yr`
};
export default ___CSS_LOADER_EXPORT___;
